var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.08 24.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0b5580;\n      }\n\n      .cls-2 {\n        fill: #63ecdb;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Interface"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 12.04,
    cy: 12.04,
    r: 12.04,
    transform: "translate(-1.77 21.99) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.99,9.8h2.33v7.49h-2.33v-7.49Zm1.17-3.72c.75,0,1.35,.6,1.35,1.35s-.6,1.35-1.35,1.35-1.35-.61-1.35-1.35,.6-1.35,1.35-1.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.78,9.8h2.23v1.02h.03c.31-.59,1.07-1.21,2.2-1.21,2.36,0,2.79,1.55,2.79,3.57v4.11h-2.33v-3.64c0-.87-.02-1.99-1.21-1.99s-1.4,.95-1.4,1.92v3.7h-2.33v-7.49Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b5f01843b39bc13e9b51ae1915d2d564.svg";
export { ForwardRef as ReactComponent };